import React from 'react';
import { Link } from 'react-router-dom';

const superAdminCards = [
  {
    title: 'Platform access',
    description: 'Manage platform-level users and super-admin assignments.',
    links: [
      { to: '/super-admin/platform-users', label: 'Platform Users' },
      { to: '/manage-platform-user-roles', label: 'Platform User Roles' },
      { to: '/manage-organization-memberships', label: 'Organization Memberships' },
    ],
  },
  {
    title: 'Organization settings',
    description: 'Review memberships, roles, and organizational access.',
    links: [
      { to: '/manage-organization-members-and-roles', label: 'Members & Roles' },
      { to: '/manage-organization-membership-roles', label: 'Membership Roles' },
      { to: '/manage-organization-requests', label: 'Requests & Invites' },
    ],
  },
  {
    title: 'System administration',
    description: 'Operate the core admin tools for courses, content, and organization setup.',
    links: [
      { to: '/manage-organizations', label: 'Organizations' },
      { to: '/manage-courses', label: 'Courses' },
      { to: '/manage-questions', label: 'Questions' },
      { to: '/manage-email-templates', label: 'Email Templates' },
      { to: '/manage-site-content', label: 'Site Content' },
    ],
  },
];

const SuperAdminDashboard: React.FC = () => {
  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 12, letterSpacing: 1.2, textTransform: 'uppercase', color: '#6b7280', fontWeight: 700 }}>
          Super Admin
        </div>
        <h1 style={{ margin: '8px 0 8px', fontSize: 32, color: '#111827' }}>Platform oversight</h1>
        <p style={{ margin: 0, color: '#4b5563', maxWidth: 900 }}>
          Use this area to manage the high-level platform controls, user privileges, organization access,
          and the shared administrative tools that span all organizations.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
        {superAdminCards.map((card) => (
          <div
            key={card.title}
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              background: '#fff',
              boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
              padding: 20,
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: 8, fontSize: 20, color: '#111827' }}>{card.title}</h2>
            <p style={{ marginTop: 0, marginBottom: 16, color: '#4b5563', lineHeight: 1.5 }}>{card.description}</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {card.links.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  style={{
                    color: '#1d4ed8',
                    textDecoration: 'none',
                    fontWeight: 600,
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
